module.exports = __webpack_public_path__ + "static/media/icon-load.9e9c92f9.gif";